export const consoleSuccessStyle = `padding: 6px; color: green; border: 1px dotted green;`;
export const consoleErrorStyle = `padding: 6px; color: red; border: 1px dotted red;`;
